import { render, staticRenderFns } from "./distributionOfIncidencesComponent.vue?vue&type=template&id=3fe5e400&scoped=true"
import script from "./distributionOfIncidencesComponent.vue?vue&type=script&lang=js"
export * from "./distributionOfIncidencesComponent.vue?vue&type=script&lang=js"
import style0 from "./distributionOfIncidencesComponent.vue?vue&type=style&index=0&id=3fe5e400&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe5e400",
  null
  
)

export default component.exports